import React from 'react';
import { Switch, Route } from 'react-router';
import { AppRoutes, getAppRouteCacheName } from '../../../routes';
import { DevicesLocation } from './DevicesLocation';
import { DevicesLocationDeviceDetails } from './devices/DevicesLocationDeviceDetails';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';
import { DeviceDataProvider } from '../../../data/DataProviders/DeviceDataProvider';
import { useCurrentAppRoute } from '../../../hooks/app-route-hooks';

export const DevicesLocationList: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();

    return (
        <>
            <Switch>
                <DataProviderCache for={getAppRouteCacheName(AppRoutes.DevicesLocation)}>
                    <Route exact path={AppRoutes.DevicesLocation} component={DevicesLocation} />
                    <Route exact path={AppRoutes.DevicesLocationDeviceDetails}>
                        {'deviceId' in currentAppRoute && (
                            <DataProviderCache for={getAppRouteCacheName(AppRoutes.DevicesLocationDeviceDetails)}>
                                <DeviceDataProvider deviceId={currentAppRoute.deviceId}>
                                    <DevicesLocationDeviceDetails />
                                </DeviceDataProvider>
                            </DataProviderCache>
                        )}
                    </Route>
                </DataProviderCache>
            </Switch>
        </>
    );
};
